export default __webpack_public_path__ + "static/media/opim-logo.0d475db7.svg";